module.exports = __webpack_public_path__ + "static/img/vip.ca0c7531.png";